import { call, put, takeEvery } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage, normalizeAuditListItem } from './helpers';

function* list({ payload: { companyId } }) {
  try {
    const { data } = yield call(dataProvider.getList, `audit/by-contractor-id/${companyId}`, {});
    const audits = Array.isArray(data) ? data : Array.isArray(data && data.data) ? data.data : [];
    const normalizedAudits = audits.map(normalizeAuditListItem);
    yield put({ type: psmAuditDigital.list.end, payload: normalizedAudits });
  } catch (e) {
    yield put({ type: psmAuditDigital.list.error });
    yield put({ type: notification.add, payload: { error: getNotificationErrorMessage(e, 'Failed to load audits') } });
  }
}

export default function* listSaga() {
  yield takeEvery(psmAuditDigital.list.start, list);
}
